import { Injectable } from '@angular/core';
import {HttpInterceptor2} from "./HttpInterceptor.service";
import {GlobalVariable} from "./global.vars";


@Injectable()
export class CompaniesService {
  private Http: HttpInterceptor2;
  private API_URL = GlobalVariable.API_URL;

  constructor (httpInterceptor: HttpInterceptor2) {
    this.Http = httpInterceptor
  }

  getCompanies(searchQuery,limit?,page?){
      let l=10;
      let p= 1;

      if (page) p=page;
      if (limit) l=limit;


      return this.Http.post(this.API_URL+'/company/query?limit='+l+'&page='+p,searchQuery)
  }



}



// WEBPACK FOOTER //
// ./src/services/companies.service.ts